import { useQuery } from "@tanstack/vue-query";
import { computed, unref } from "vue";
import http from "@/helper/http";
import api from "@/helper/api";
import { RESOURCE_CACHE, queryKeys } from "@/config/queryConfig";

// ==================== REQUEST LOGS ====================

export function useRequestLogs(filters = {}, options = {}) {
  return useQuery({
    queryKey: queryKeys.requestLogs(filters),
    queryFn: async () => {
      const actualFilters = unref(filters);

      const params = {
        page: actualFilters.page || 1,
        per_page: actualFilters.per_page || 50,
        ...actualFilters,
      };

      console.log("RequestLogs API Request:", {
        url: api.admin_request_logs,
        params: params,
        actualFilters: actualFilters,
      });

      const response = await http.get(api.admin_request_logs, {
        params,
      });

      console.log("RequestLogs API Response:", {
        data: response.data,
        pagination: {
          page: response.data?.page,
          pages: response.data?.pages,
          per_page: response.data?.per_page,
          total: response.data?.total,
        },
      });

      return response.data;
    },
    enabled: computed(() => true), // Always enabled for admin
    staleTime: 30 * 1000, // 30 seconds - prevent rapid refetches
    refetchOnWindowFocus: false, // Disable automatic refetch on window focus
    ...RESOURCE_CACHE.requestLogs,
    ...options,
  });
}

export function useRequestLogDetails(id, options = {}) {
  return useQuery({
    queryKey: queryKeys.requestLogDetails(id),
    queryFn: async () => {
      const actualId = unref(id);
      if (!actualId) {
        throw new Error("Request log ID is required");
      }

      const response = await http.get(api.admin_request_log_details(actualId));
      return response.data;
    },
    enabled: computed(() => {
      const actualId = unref(id);
      return !!actualId;
    }),
    ...RESOURCE_CACHE.requestLogDetails,
    ...options,
  });
}
